<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">8.</span>
          <span>Dislocated Worker</span>
        </div>
        <p>Please enter your information regarding your eligibility in WIOA.</p>
        <el-form @submit.native.prevent="updateCheckList">
          <div class="content-type">
            <p class="heavy-text">Category 3</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Have you been previously self-employed?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryThree.SelfEmployed.IsPreviouslySelfEmployed'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryThree.selfEmployed
                        .isPreviouslySelfEmployed
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <p>
                  Please upload a copy of your<em style="cursor: default;">
                    Business license/permit</em>, <em style="cursor: default">IRS documentation
                  </em>
                  or <em style="cursor: default;">State verification</em>.
                </p>
                <el-form-item>
                  <el-upload
                    drag
                    action="selfEmployed"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon selfEmployed"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="selfEmployedFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you presently unemployed because of general economic
                  conditions in your residing community?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryThree.PresentlyUnemployed.IsPresentlyUnemployed'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryThree.presentlyUnemployed
                        .isPresentlyUnemployed
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <p>
                  Please upload evidence of economic conditions in your residing
                  community if available.
                </p>
                <el-form-item>
                  <el-upload
                    drag
                    action="presentlyUnemployed"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon presentlyUnemployed"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="presentlyUnemployedFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Have you been permanently dislocated because of natural
                  disaster?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryThree.PermanentlyDislocated.IsPermanentlyDislocated'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryThree.permanentlyDislocated
                        .isPermanentlyDislocated
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <p>
                  Please upload a
                  <em style="cursor: default;"
                    >Federal/State declaration of disaster
                  </em>
                  or
                  <em style="cursor: default;">State-confirmed disaster</em> and
                  <em style="cursor: default;"
                    >Permanent dislocation if available</em
                  >.
                </p>
                <el-form-item>
                  <el-upload
                    drag
                    action="permanentlyDislocated"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon permanentlyDislocated"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="permanentlyDislocatedFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-outline wioa-btn-outline"
                  @click="backToDashboard"
                >
                  Previous
                </el-button>
              </el-col>
              <el-col :offset="2" :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="updateCheckList"
                >
                  Continue
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import { BucketType } from "@/enums";
import * as utils from "@/utils";

export default {
  components: { CheckListTemplate, TSLoading },
  data() {
    return {
      modelState: {},
      loading: false,
      selfEmployedFileList: [],
      presentlyUnemployedFileList: [],
      permanentlyDislocatedFileList: [],
      dislocatedWorker: {
        categoryThree: {
          selfEmployed: { isPreviouslySelfEmployed: null, clientFiles: [] },
          presentlyUnemployed: { isPresentlyUnemployed: null, clientFiles: [] },
          permanentlyDislocated: {
            isPermanentlyDislocated: null,
            clientFiles: []
          }
        }
      },
      newSelfEmployedUploadInd: false,
      newPresentlyUnemployedUploadInd: false,
      newPermanentlyDislocatedUploadInd: false,
      validFileExtensions: [
        ...utils.imageFileExtensions,
        ...utils.documentFileExtensions
      ],
      document: {
        type: Object,
        default() {
          return {
            id: "",
            name: "",
            filename: "",
            documentObjectId: "",
            documentObjectUrl: "",
            isImage: false
          };
        }
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm("Are you sure you want to leave this page?", "Warning!", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        center: true
      })
      .then(() => {
        if(this.newSelfEmployedUploadInd || this.newPresentlyUnemployedUploadInd || this.newPermanentlyDislocatedUploadInd)
        {
            if(this.dislocatedWorker.categoryThree.selfEmployed.clientFiles[0].fileId && this.newSelfEmployedUploadInd){
              this.navigateAwayRemoveAttachment(this.dislocatedWorker.categoryThree.selfEmployed.clientFiles[0].fileId);
              this.dislocatedWorker.categoryThree.selfEmployed.clientFiles = [];
            }
            
            if(this.dislocatedWorker.categoryThree.presentlyUnemployed.clientFiles[0].fileId && this.newPresentlyUnemployedUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.dislocatedWorker.categoryThree.presentlyUnemployed.clientFiles[0].fileId);
              this.dislocatedWorker.categoryThree.presentlyUnemployed.clientFiles = [];
            }

            if(this.dislocatedWorker.categoryThree.permanentlyDislocated.clientFiles[0].fileId && this.newPermanentlyDislocatedUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.dislocatedWorker.categoryThree.permanentlyDislocated.clientFiles[0].fileId);
              this.dislocatedWorker.categoryThree.permanentlyDislocated.clientFiles = [];
            }

            this.$message.success("Your checklist are saved as draft!");
            localStorage.removeItem("editChecklist");
            next();
        }
        else
        {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem("editChecklist");
          next();
        }
      })
      .catch(() => false);
    } else {
      next();
    }
  },
  created() {
    window.scrollTo(0,0);
    if (this.editChecklistId) {
      this.loading = true;
      this.$store
        .dispatch("wioa/getChecklistToReview", this.editChecklistId)
        .then(res => {
          if (res.checklist.dislocatedWorker.categoryThree)
          {
            this.dislocatedWorker.categoryThree = res.checklist.dislocatedWorker.categoryThree;
            res.checklist.dislocatedWorker.categoryThree.selfEmployed.clientFiles.forEach(element => {
              this.selfEmployedFileList.push({'name': element.fileName, 'url': element.fileId});
            });

            res.checklist.dislocatedWorker.categoryThree.presentlyUnemployed.clientFiles.forEach(element => {
              this.presentlyUnemployedFileList.push({'name': element.fileName, 'url': element.fileId});
            });

            res.checklist.dislocatedWorker.categoryThree.permanentlyDislocated.clientFiles.forEach(element => {
              this.permanentlyDislocatedFileList.push({'name': element.fileName, 'url': element.fileId});
            });
          }
            
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    navigateAwayRemoveAttachment(objectId){
      const param = {
          objectId: objectId,
          bucketType: BucketType.WioaChecklist,
        };
        this.$store
          .dispatch("common/removefile", param)
          .then(() => {
            return true;
          })
          .catch((res) => {
            this.$message.success("Something went wrong. Please contact talentsensus admin.");
            return false
          });
    },
    removeUpload(file, fileList){
      let uploadElement = event.target.parentElement.parentElement.parentElement;
      this.loading = true;
      file.url = (file.url == null && file.name != null) ? file.raw.url : file.url;
      const param = {
        objectId: file.url,
        bucketType: BucketType.WioaChecklist
      };
      this.$store.dispatch("common/removefile", param).then(() => {
        if(uploadElement.classList.contains('selfEmployed'))
        {
          this.dislocatedWorker.categoryThree.selfEmployed.clientFiles = [];
        }
        else if(uploadElement.classList.contains('presentlyUnemployed'))
        {
          this.dislocatedWorker.categoryThree.presentlyUnemployed.clientFiles = [];
        }
        else if(uploadElement.classList.contains('permanentlyDislocated'))
        {
          this.dislocatedWorker.categoryThree.permanentlyDislocated.clientFiles = [];
        }
        this.$message.success("Document removed!");
      })
      .catch((res) => {
      })
      .finally(() => {
        this.loading = false;
      });
    },
    handleExceed(){
      this.showPopUpMessage(
          "Upload",
          `You can only upload 1 file.`
        );
    },
    getChecklistId() {
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({
        name: "WioaChecklistSeven",
        params: { checklistId: this.getChecklistId() }
      });
    },
    updateCheckList() {
      this.loading = true;
      let checklist = {
        type: 3.3,
        checklist: {
          id:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId,
          dislocatedWorker: this.dislocatedWorker
        }
      };
      this.$store
        .dispatch("wioa/completeCheckList", checklist)
        .then(res => {
          if (res) {
            this.$router.push({
              name: "WioaChecklistNine",
              params: { checklistId: this.getChecklistId() }
            });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadDocument(param) {
      this.loading = true;

      this.$store
        .dispatch(
          "wioa/generateUploadDocumentMetadata",
          this.editChecklistId == null
            ? this.getChecklistId()
            : this.editChecklistId
        )
        .then(metadata => {
          this.storeDocument(param, metadata);
        })
        .catch(err => param.onError(err, param.file, param.fileList));
    },
    storeDocument(param, metadata) {
      const { file } = param;
      const fileExtension = utils.getFileExtension(file.name);

      this.$store
        .dispatch("common/uploadDocumentWithReturnUrl", {
          file,
          objectId:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
          bucketType: BucketType.WioaChecklist,
          fileExtension
        })
        .then(url => {
          this.document.id = metadata.documentId;
          this.document.filename = file.name;
          this.document.isImage = utils.isImage(file.name);
          this.document.documentObjectId = metadata.documentObjectId;
          this.document.documentObjectUrl = url;

          if (param.action == "selfEmployed") {
            this.dislocatedWorker.categoryThree.selfEmployed.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newSelfEmployedUploadInd = true;
          } else if (param.action == "presentlyUnemployed") {
            this.dislocatedWorker.categoryThree.presentlyUnemployed.clientFiles.push(
              {
                fileId:
                  this.editChecklistId == null
                    ? this.getChecklistId()
                    : this.editChecklistId +
                      "/JobSeeker/" +
                      metadata.documentId,
                fileName: file.name
              }
            );
            this.newPresentlyUnemployedUploadInd = true;
          } else {
            this.dislocatedWorker.categoryThree.permanentlyDislocated.clientFiles.push(
              {
                fileId:
                  this.editChecklistId == null
                    ? this.getChecklistId()
                    : this.editChecklistId +
                      "/JobSeeker/" +
                      metadata.documentId,
                fileName: file.name
              }
            );
            this.newPermanentlyDislocatedUploadInd = true;
          }
          param.file.url = this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId;
        })
        .catch(err => {
          param.onError(err, param.file, param.fileList);
        })
        .finally(() => (this.loading = false));
    },
    beforeUpload(file) {
      const fileExtension = utils.getFileExtension(file.name);

      if (this.validFileExtensions.indexOf(fileExtension) === -1) {
        this.showPopUpMessage(
          "Upload",
          `Invalid file type. Only ${this.validFileExtensions.join(
            ", "
          )} are allowed.`
        );
        this.loading = false;
        return false;
      }

      const fileLimitExceeded = file.size / 1024 / 1024 > 3;
      if (fileLimitExceeded) {
        this.showPopUpMessage("Upload", "File size cannot exceed 3MB");
        this.loading = false;
        return false;
      }

      return true;
    },
    onError() {
      this.loading = false;
      this.presignedUpdateUrl = "";

      this.document.id = "";
      this.document.filename = "";
      this.document.documentObjectId = "";
      this.document.documentObjectUrl = "";
      this.document.isImage = false;

      this.showPopUpMessage("Upload", "Unable to upload file.");
    },
    showPopUpMessage(title, msg, type = "error") {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => false);
    },
    isImage(filename) {
      return utils.isImage(filename);
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem("editChecklist");
    }
  }
};
</script>
